<tds-modal size="md" closeIconButtonLabel="Close">
  <tds-modal-title>{{ isEdit() ? 'Edit PMO' : 'New PMO' }}</tds-modal-title>

  <div class="pmo-form">
    <div class="pmo-field">
      <label class="pmo-field-label" for="pmo-file-input">PMO file</label>
      <div class="pmo-file">
        <input id="pmo-file-input" #fileInput type="file" class="pmo-file-input" (change)="onFileSelected($event)" />
        <button tds-button variant="secondary" type="button" (click)="fileInput.click()">
          <tds-icon name="upload" />
          Choose file
        </button>
        <span class="pmo-file-name">{{ fileName() || 'No file selected' }}</span>
      </div>
      @if (fileError()) {
        <span class="pmo-error">Select a PMO file before saving.</span>
      }
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Zones</mat-label>
      <mat-select
        multiple
        [value]="selectedZoneIds()"
        (selectionChange)="onZonesChange($event.value)"
      >
        @for (zone of regionsViewModel().regions; track zone.id) {
          <mat-option [value]="zone.id">{{ zone.name }} - {{ zone.alias }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Sources</mat-label>
      <mat-select
        multiple
        [value]="selectedSourceIds()"
        (selectionChange)="onSourcesChange($event.value)"
      >
        @for (source of sourcesViewModel().sources; track source.id) {
          <mat-option [value]="source.id">{{ source.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <fieldset class="pmo-releases">
      <legend>Releases</legend>

      <tds-form-field>
        <tds-form-field-label>Add an existing release</tds-form-field-label>
        <tds-dropdown tds-form-field-item [items]="releaseOptions()" (valueChange)="onReleasePicked($event)">
          Select an existing release
        </tds-dropdown>
      </tds-form-field>

      <div class="pmo-new-release">
        <tds-form-field class="pmo-grow">
          <tds-form-field-label>Add a new release</tds-form-field-label>
          <input
            tds-form-field-item
            type="text"
            placeholder="e.g. 2025 - Q2"
            [value]="newRelease()"
            (input)="onNewReleaseChange($event)"
            (keydown.enter)="addNewRelease()"
          />
        </tds-form-field>
        <button tds-button variant="secondary" [disabled]="!newRelease().trim()" (click)="addNewRelease()">
          <tds-icon name="add" />
          Add
        </button>
      </div>

      @if (selectedReleases().length > 0) {
        <div class="pmo-tags">
          @for (release of selectedReleases(); track release) {
            <tds-tag isClosable closeIconButtonLabel="Remove release" (close)="removeRelease(release)">
              {{ release }}
            </tds-tag>
          }
        </div>
      }
    </fieldset>

    @if (pmoViewModel().error) {
      <div class="pmo-error">{{ pmoViewModel().error }}</div>
    }
  </div>

  <tds-modal-actions>
    <button tds-button variant="tertiary" (click)="close()">Cancel</button>
    <button tds-button (click)="save()" [disabled]="pmoViewModel().isSaving">Save</button>
  </tds-modal-actions>
</tds-modal>


